import Konva from 'konva';

export const createSoilSurveyPopupElements = (onClose: () => void) => {
    const popupDiv = document.createElement('div');
    popupDiv.id = 'soil-survey-popup';
    popupDiv.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        z-index: 10000;
        padding: 0;
        overflow: hidden;
    `;

    const headerBar = document.createElement('div');
    headerBar.style.cssText = `
        background: #f5f5f5;
        border-bottom: 1px solid #ddd;
        padding: 10px;
        height: 40px;
        position: relative;
    `;

    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = '×';
    closeBtn.style.cssText = `
        position: absolute;
        top: 5px;
        right: 5px;
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        width: 30px;
        height: 30px;
        color: #666;
    `;
    closeBtn.onclick = onClose;
    headerBar.appendChild(closeBtn);

    const container = document.createElement('div');
    container.id = 'soil-survey-canvas-container';
    container.style.cssText = `
        width: 700px;
        height: 800px;
        background: white;
    `;

    popupDiv.appendChild(headerBar);
    popupDiv.appendChild(container);

    const overlay = document.createElement('div');
    overlay.id = 'soil-survey-overlay';
    overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 9999;
    `;
    overlay.onclick = onClose;

    return { popupDiv, overlay, container };
};

export const drawTableGrid = (layer: Konva.Layer, x: number, y: number, colWidth: number, height: number) => {
    for (let i = 0; i <= 3; i++) {
        const line = new Konva.Line({
            points: [x, y + i * 30, x + 4 * colWidth, y + i * 30],
            stroke: i === 0 || i === 4 ? 'black' : '#ddd',
            strokeWidth: i === 0 || i === 3 ? 1 : 0.5,
        });
        layer.add(line);
    }

    for (let i = 0; i <= 4; i += 1) {
        for (let j = 0; j <= 3; j += 1) {
            if ((j === 0 && i === 1) || (j === 1 && i === 1) || (j === 3 && i === 1)) {
                continue;
            }

            const line = new Konva.Line({
                points: [x + i * colWidth, (height / 3) * j + y, x + i * colWidth, y + (height / 3) * (j + 1)],
                stroke: i === 0 || i === 4 ? 'black' : '#ddd',
                strokeWidth: i === 0 || i === 4 ? 1 : 0.5,
            });
            layer.add(line);
        }
    }
};

export const addTableCell = (layer: Konva.Layer, text: string, x: number, y: number, fontSize: number, color = 'black', maxWidth?: number, activeTooltips: HTMLElement[] = []) => {
    let displayText = text;
    let isTruncated = false;

    if (maxWidth) {
        const tempText = new Konva.Text({
            text: text,
            fontSize: fontSize,
            fontFamily: 'Arial',
        });

        if (tempText.width() > maxWidth) {
            let truncatedText = text;
            do {
                truncatedText = truncatedText.slice(0, -1);
                tempText.text(truncatedText + '...');
            } while (tempText.width() > maxWidth && truncatedText.length > 0);

            displayText = truncatedText + '...';
            isTruncated = true;
        }
    }

    const cell = new Konva.Text({
        x: x,
        y: y,
        text: displayText,
        fontSize: fontSize,
        fontFamily: 'Arial',
        fill: color,
    });

    if (isTruncated) {
        cell.listening(true);

        let tooltip: HTMLDivElement | null = null;

        const showTooltip = (e: Konva.KonvaEventObject<MouseEvent>) => {
            if (tooltip) {
                document.body.removeChild(tooltip);
                const index = activeTooltips.indexOf(tooltip);
                if (index > -1) {
                    activeTooltips.splice(index, 1);
                }
            }

            tooltip = document.createElement('div');
            tooltip.style.cssText = `
                position: fixed;
                background: rgba(0, 0, 0, 0.8);
                color: white;
                padding: 8px 12px;
                border-radius: 4px;
                font-size: 12px;
                font-family: Arial, sans-serif;
                z-index: 10001;
                pointer-events: none;
                max-width: 300px;
                word-wrap: break-word;
                box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            `;
            tooltip.textContent = text;
            document.body.appendChild(tooltip);
            activeTooltips.push(tooltip);

            const updateTooltipPosition = (clientX: number, clientY: number) => {
                if (tooltip) {
                    tooltip.style.left = clientX + 10 + 'px';
                    tooltip.style.top = clientY - 10 + 'px';
                }
            };

            updateTooltipPosition(e.evt.clientX, e.evt.clientY);
        };

        const hideTooltip = () => {
            if (tooltip) {
                document.body.removeChild(tooltip);
                const index = activeTooltips.indexOf(tooltip);
                if (index > -1) {
                    activeTooltips.splice(index, 1);
                }
                tooltip = null;
            }
        };

        const updateTooltipPosition = (e: Konva.KonvaEventObject<MouseEvent>) => {
            if (tooltip) {
                tooltip.style.left = e.evt.clientX + 10 + 'px';
                tooltip.style.top = e.evt.clientY - 10 + 'px';
            }
        };

        cell.on('mouseenter', showTooltip);
        cell.on('mouseleave', hideTooltip);
        cell.on('mousemove', updateTooltipPosition);

        cell.on('mouseenter', () => {
            document.body.style.cursor = 'help';
        });
        cell.on('mouseleave', () => {
            document.body.style.cursor = 'default';
        });
    }

    layer.add(cell);
};
